import { GridRow, gridRowProps } from '@camelot/core';
import { GraphSchema } from '@camelot/server';

export interface PurchaseOrderGridRow extends GridRow {
  activityIds: string[];
  budgetLineId: string | null;
  deliveryModes: number[];
  itemId: string | null;
  rowPricingType: number | null;
}

const props: (keyof PurchaseOrderGridRow)[] = [
  'activityIds',
  'budgetLineId',
  'deliveryModes',
  'itemId',
  'rowPricingType',
];

export const purchaseOrderGridRowProps = new GraphSchema<PurchaseOrderGridRow>(props.concat(gridRowProps));
